export default __webpack_public_path__ + "static/media/newsletter-popup-img-01.20a7b4ba.jpg";